import {Pipe, PipeTransform} from '@angular/core';
import {Decimal} from 'decimal.js';

@Pipe({
    name: 'delMinQty',
    pure: true
})
export class DelMinQtyPipe implements PipeTransform {

    public transform(dp: number): number {
        return new Decimal(10).pow(-dp).toNumber();
    }

}
